import { lazy, Suspense } from "react";
import { PageSkeleton } from "../../../customs/skeleton/main";

const Main = lazy(() => import("../../../components/settings/learningTraining/eventType/main"));

const EventType = () => {
  return (
        <Suspense fallback={<PageSkeleton />}>
          <Main />
        </Suspense>
  );
};

export default EventType;

